import { render, staticRenderFns } from "./DictManager.vue?vue&type=template&id=06dbb84a&scoped=true"
import script from "./DictManager.vue?vue&type=script&lang=js"
export * from "./DictManager.vue?vue&type=script&lang=js"
import style0 from "./DictManager.vue?vue&type=style&index=0&id=06dbb84a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06dbb84a",
  null
  
)

export default component.exports